import { Copy } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import CompraRapidaService from "@/services/CompraRapidaService";
import clsx from "clsx";
import { Dialog, DialogContent, DialogDescription, DialogHeader } from "@/components/ui/dialog";
import { labelPlural } from "@/utils/copyTituloBilhete";

export function EtapaPagamentoQrCode() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const { toast } = useToast()
    const { state } = location;
    const [pagamentoRealizado, setPagamentoRealizado] = useState(false);
    const [idCompra, setIdCompra] = useState(0);
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const isAndroid = navigator.userAgent.toLowerCase().includes("android");
    const isInstagram = navigator.userAgent.toLowerCase().includes("instagram")
    const isFluxoGiro = location.pathname.toLowerCase().includes("/compra/rapida/giro");
    const fallbackPath = isFluxoGiro ? "/" : "/compra/titulos";

    useEffect(() => {
        if (!state) {
            navigate(fallbackPath);
            return;
        }

        setLoading(false)

        timerRef.current = setInterval(() => {
            handleVerificarPagamentoPix()
        }, 8000)

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current)
            }
        }
    }, [])

    async function handleVerTitulos() {
        navigate(`/compra/detalhes/${idCompra}?tokenCompraRapida=${encodeURIComponent(state.token)}&comprarapida=1`);
        navigate(0)
    }

    async function handleVerificarPagamentoPix() {
        try {
            const { Data: result } = await CompraRapidaService.consultarPixPago(state.token)
            if (result.Situacao === 1 && timerRef.current) {
                setPagamentoRealizado(true)
                setIdCompra(result.Compra.IdCompra)
                clearInterval(timerRef.current)
            }
        } catch (error: any) {
            toast({
                variant: 'destructive',
                description: error,
                duration: 4000
            });
        }
    }

    return loading ? <>Carregando...</> : (
        <>
            {
                state.qrCode && (
                    <div className="flex flex-col md:flex-row">
                        <div className="md:w-[70%]">
                            <p className={clsx(
                                "flex justify-center text-2xl",
                                {
                                    "text-primary-foreground": !pagamentoRealizado,
                                    "text-green-600": pagamentoRealizado
                                }
                            )}>
                                {
                                    pagamentoRealizado ? 'Pagamento Aprovado' : 'Aguardando Pagamento'
                                }
                            </p>
                            <p className="flex justify-center text-lg text-primary-foreground">Valor da Compra: {state.qrCode.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
                            {
                                !pagamentoRealizado && (<p className="flex justify-center text-lg text-primary-foreground">Tempo de Expiração: 10 minutos</p>)
                            }

                            <div className="flex justify-center">
                                <img src={(state.qrCode.QrCode.indexOf('http') < 0 ? "data:image/png;base64, " : '') + state.qrCode.QrCode} alt="Imagem do QrCode" />
                            </div>
                        </div>
                        <div className="self-center w-full mb-10">
                            {
                                !pagamentoRealizado && (
                                    <div className="flex flex-col justify-center px-10 gap-3">
                                        <Input readOnly value={state.qrCode.QrCodeText} type="text" />
                                        <Button className="self-center gap-2 w-full" onClick={async () => {
                                            await navigator.clipboard.writeText(state.qrCode.QrCodeText);
                                            toast({
                                                variant: 'success',
                                                description: 'Código copiado com sucesso!',
                                                duration: 3000
                                            })
                                        }}><Copy />Copiar Pix Copia e Cola</Button>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                )
            }

            <Dialog open={pagamentoRealizado}>
                <DialogContent>
                    <DialogHeader>
                        <DialogDescription className="gap-5 flex flex-col hidden">
                            Pagamento aprovado
                        </DialogDescription>
                    </DialogHeader>

                    <p className={clsx("flex justify-center text-2xl text-green-600")}>
                        PAGAMENTO APROVADO
                    </p>

                    <div className="flex justify-center">
                        <svg width="80" height="80" viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="512" cy="512" r="410" fill="#22C55E" />
                            <path d="M329 539.01l124.244 124.244a30 30 0 0042.426 0L695 463.927" stroke="white" strokeWidth="72" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>

                    <div className="flex justify-center mt-6">
                        {
                            (isAndroid && isInstagram) ? (
                                <a
                                    href={`${window.location.origin}/compra/detalhes/${idCompra}?tokenCompraRapida=${encodeURIComponent(state.token)}&comprarapida=1`}
                                    target="_blank"
                                    download
                                    className="m-1 inline-block"
                                >
                                    <button
                                        className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline">
                                        Ver {labelPlural()}
                                    </button>
                                </a>
                            ) : (
                                <button
                                    className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
                                    onClick={handleVerTitulos}
                                >
                                    Ver meus {labelPlural()}
                                </button>
                            )
                        }
                    </div>


                </DialogContent>
            </Dialog >
        </>
    )
}